
var util = {};


util.object_pick = ( o_obj, a_keys ) => {
   var i, l, c_key, o_new = {};

   for( i = 0, l = a_keys.length; i < l; i++ ){
      c_key = a_keys[ i ];
      if( o_obj.hasOwnProperty( c_key ) ){
         o_new[ c_key ] = o_obj[ c_key ];
      }
   }// /for()

   return o_new;
};// /object_pick()
   
/**
 * 12-16-2014
 * This method tries to convert a string into an integer. If it fails we
 * return a default number.
 * ~~ Scott Johnson
 */
util.toInt = function( cString, nDefault ) {
   var n = parseInt( cString, 10 );
   
   nDefault = nDefault || 0;
   
   if ( isNaN( n ) ) {
      return nDefault;
   }
   
   return n;
};// /toInt()

export default util;